import { RENTAL_PORTAL_LISTING_STATUSES } from '../../../../../../constants/rentalPortal'
import { EntityStatus } from '../../../../../Entity'
import { ListingProfileWidgetPublishingCheck } from '../ListingProfileWidgetPublishingCheck'
import { ListingProfileWidgetPublishingCount } from '../ListingProfileWidgetPublishingCount'
import { ListingProfileWidgetPublishingManageButton } from '../ListingProfileWidgetPublishingManageButton'

import * as styles from './ListingProfileWidgetPublishingReadiness.module.css'

function ListingProfileWidgetPublishingReadiness({
  doneCount,
  fixHandlers,
  isManageDisabled,
  listingStatus,
  manageTooltipKey,
  rows,
  total,
  onClickManage,
}) {
  return (
    <>
      <EntityStatus
        id={listingStatus}
        statuses={RENTAL_PORTAL_LISTING_STATUSES}
      />
      <ListingProfileWidgetPublishingCount
        isSecondary
        doneCount={doneCount}
        total={total}
      />
      <div className={styles.checks}>
        {rows.map(({ key, ...row }) => (
          <ListingProfileWidgetPublishingCheck
            {...row}
            key={key}
            onClickFix={fixHandlers[key]}
          />
        ))}
      </div>
      <ListingProfileWidgetPublishingManageButton
        isDisabled={isManageDisabled}
        tooltipKey={manageTooltipKey}
        onClick={onClickManage}
      />
    </>
  )
}

export default ListingProfileWidgetPublishingReadiness
